import { render, staticRenderFns } from "./ActionsSummary.vue?vue&type=template&id=71c88d00&"
import script from "./ActionsSummary.vue?vue&type=script&lang=js&"
export * from "./ActionsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports